import { Box, styled } from "@mui/material";

export const AnalyticsHeaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingInline: "36px",
  borderBottom: "1px solid lightGray",
  backgroundColor: "white"
}));